<template>
  <div class="no-shrink preview">
    <div class="flex column center-all">
      <span v-if="!content || (!content.text && !hasAttachment)" style="font-size: 40px;">💬</span>
      <div
        v-else
        class="template-message-wrapper"
        :class="{ document: content.attachmentType && ['file', 'pdf', 'excel', 'powerpoint', 'word', 'text'].includes(content.attachmentType.toLowerCase()), buttons: content.buttons && content.buttons.length }" >
        <div
          class="template-message"
          :class="{ buttons: (content.buttons && content.buttons.items && contentReactive.buttons.items.length) || (content.menu && content.menu.menu_title) }">
          <div
            v-if="content.attachmentType && ['file', 'pdf', 'excel', 'powerpoint', 'word', 'text'].includes(content.attachmentType.toLowerCase())"
            class="document-preview flex center-all" >
            <SBIcon
              :icon="SBIconList.DOWNLOAD"
              :size="15"
              :color="SBColors.white" />
            <span class="title ml-2 ellipsis">{{ content.attachment.name }}</span>
          </div>
          <div
            v-else-if="content.attachmentType && content.attachmentType.toLowerCase() === 'video'"
            style="position: relative; margin: 0; overflow: hidden; padding: 0; height: 95px;"
            class="video" >
            <video
              style="width: 100%; height: 1000%; transform: translateY(calc(-45%));"
              :src="content.attachment.url" />
          </div>
          <div
            v-else-if="hasAttachment"
            class="attachment"
            :class="[content.attachmentType.toLowerCase(), { placeholder: !exampleUrl, 'video-overlay': exampleUrl && content.attachmentType.toLowerCase() === 'video' }]"
            :style="{ 'background-image': `url(${exampleUrl})` }" />
          <div
            v-if="content.text"
            class="content-wrapper">
            <MessageContent
              :content="content.text"
              :detect-urls="true"
              :convert-tag-to-button="true"/>
          </div>
        </div>

        <!-- BUTTONS -->
        <template v-if="content.buttons && content.buttons.items && contentReactive.buttons.items.length">
          <div
            v-for="(button, index) in content.buttons.items"
            :id="`button-${index}`"
            :key="index"
            class="button" >
            <img
              v-if="button.icon"
              :src="/\{\{\d*\}\}$/.test(button.value) ? button.icon.grey : button.icon.dark"
              height="12"
              class="menu-icon mr-2" >
            <span
              v-if="button.title"
              :class="{ waiting: /\{\{\d*\}\}$/.test(button.value) }"
              class="ellipsis" >{{ button.title }}</span>
            <span
              v-else
              class="skeleton" />
          </div>
        </template>

        <!-- Menu -->
        <template v-if="content.menu && content.menu.menu_title">
          <div class="button" >
            <SBIcon
              class="mr-1"
              :icon="SBIconList.LIST"
              :color="SBColors.bluePrimary"
              :size="12" />
            <span
              v-if="content.menu.menu_title"
              class="ellipsis" >{{ content.menu.menu_title }}</span>
            <span
              v-else
              class="skeleton" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getThumbnails } from 'video-metadata-thumbnails';
import pdf from 'vue-pdf';

import { whatsappFormatMessage, convertToTagView, whatsAppFormatToHTML } from '@/helpers/stringHelpers';
import { getFileExtension, getMediaType, getMediaTypeForLastMessage, allowedTemplateMessageAttachments, getMediaName } from '@/helpers/mediaHelpers';
import ToasterMixin from '@/mixins/Toaster';
import MessageContent from '@/components/common/MessageContent';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'MessagePreview',
  components: {
    pdf,
    MessageContent,
    SBIcon,
  },
  mixins: [
    ToasterMixin,
  ],
  props: {
    content: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      exampleUrl: '',
      SBIconList,
      SBColors,
    };
  },
  computed: {
    hasAttachment() {
      return this.content.attachmentType;
    },
    contentReactive() {
      return this.content;
    },
  },
  watch: {
    content: {
      handler: function f() {
        this.getAttachmentUrl();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    whatsAppFormatToHTML,
    copyToClipboard(success = true) {
      if (success) {
        this.showToaster('Copied to clipboard.', null, null, 'OK');
      }
    },
    getMediaIcon(mediaType) {
      let icon = null;
      switch (mediaType) {
        case 'pdf':
          icon = this.SBIconList.PDF;
          break;
        case 'excel':
          icon = this.SBIconList.XLS;
          break;
        case 'powerpoint':
          icon = this.SBIconList.PPT;
          break;
        default:
          icon = this.SBIconList.DOC;
          break;
      }
      return icon;
    },
    getAttachmentUrl() {
      // console.log(111);
      if (this.content.attachment && this.content.attachment.name) {
        // console.log(222, this.content.attachment);
        const mediaType = this.content.attachment.type ? getMediaType(this.content.attachment.type) : getMediaType(getFileExtension(this.content.attachment.name));
        // console.log('Media', mediaType);
        if (mediaType === 'video') {
          this.parseVideoThumbnails(this.content.attachment);
          return;
        }
        if (mediaType === 'document') {}

        const URLObj = window.URL || window.webkitURL;
        this.exampleUrl = this.content.attachment.url.startsWith('http') ? this.content.attachment.url : URLObj.createObjectURL(this.content.attachment);
      } else {
        this.exampleUrl = '';
      }
    },
    async parseVideoThumbnails(videoBlob) {
      const thumbnails = await getThumbnails(videoBlob, {
        quality: 0.6,
        start: 0,
        end: 0,
        scale: 0.5,
      });
      const URLObj = window.URL || window.webkitURL;
      this.exampleUrl = URLObj.createObjectURL(thumbnails[0].blob);
    },
  },
};
</script>

<style lang="scss" scoped>
.preview {
  * {
    white-space: normal !important;
  }
  background: $white;

  & > div {
    min-height: 100%;
  }
}

.template-message-wrapper {
  width: fit-content;
  max-width: 288px;
  width: 100%;

  &.document, &.buttons {
    max-width: 100%;
    width: unset !important;
  }

  .template-message {
    border-radius: 19px;
    overflow: hidden;
    border: 2px solid $bluePrimary;
    background-color: $bluePrimary;
    color: $white;

    .content-wrapper {
      padding: 10px;
      font-size: 14px !important;
      word-break: break-word;
      text-align: left;

      ::v-deep a {
        color: $white !important;
      }

      ::v-deep {
        span {
          white-space-collapse: preserve !important;
        }
      }
    }

    .document-preview {
      padding: 10px;
      font-size: 12px;
      span {
        // margin-top: 10px !important;
        // margin-bottom: 0 !important;
        white-space: nowrap !important;
        width: 100%;
      }
    }

    div.video::after {
      content: '';
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url(~@/assets/img/video-overlay.svg);
      background-size: 22px;
      background-repeat: no-repeat;
      background-position: center;
      background-color: rgba(20,28,32,.3);
      opacity: 1;
    }

    .attachment {
      background-color: #f0f6fe;
      height: 95px;
      width: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      overflow: hidden;

      &.placeholder::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background-image: unset !important;
        background-color: #65a5f1 !important;
        mask: url(~@/assets/img/SB-Icons/doc-new.svg) no-repeat center !important;
        mask-size: 26px 26px !important;
      }

      &.image::after {
        mask: url(~@/assets/img/SB-Icons/image-placeholder.svg) no-repeat center !important;
        mask-size: 26px 26px !important;
      }

      &.video::after {
        mask: url(~@/assets/img/SB-Icons/video-placeholder.svg) no-repeat center !important;
        mask-size: 26px 26px !important;
      }

      &.video.video-overlay::after {
        mask: unset !important;
        mask-size: unset !important;
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background-image: url('~@/assets/img/video-overlay.svg');
        background-size: 52px;
        background-repeat: no-repeat;
        background-position: center;
        background-color: rgba(red($blackPrimary), green($blackPrimary), blue($blackPrimary), 0.3);
        opacity: 1;
      }

      &.document.document-overlay::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background: linear-gradient(215deg, rgba(20,28,32,0.75) 0%, rgba(255,255,255,0) 18%);
        opacity: 1;
        position: absolute;
        top: 0;
      }
      &.document.document-overlay::after {
        mask-image: url('~@/assets/img/SB-Icons/download-arrow.svg') !important;
        mask-size: 16px 16px !important;
        content: '';
        display: block;
        width: 20px;
        height: 20px;
        background-color: $white !important;
        mask-repeat: no-repeat;
        mask-position: center;
        opacity: 1;
        position: absolute;
        top: 5px;
        right: 5px;
      }
    }

    // .show-play-overlay

    .message-body {
      background-color: $bluePrimary;
      padding: 5px 12px;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.37;
      color: $white;

      ::v-deep .template-tag, ::v-deep .editor-tag,
      ::v-deep .template-tag, ::v-deep span code {
        color: $white !important;
        border: 1px solid $white !important;
        background-color: #4190ed !important;
        margin-right: 1px;
        line-height: 1.2;
        font-size: 12px !important;
        font-weight: 500 !important;
        padding: 0 7px !important;
        border-radius: 9px !important;
        margin-right: 0;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Ubuntu, sans-serif !important;
      }
    }

    &.buttons {
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    ::v-deep {
      p {
        min-height: 10px;
      }
    }
  }

  &.document .template-message .message-body {
    padding: 7px 11px;
  }

  .button {
    margin-top: 3px;
    border: 1px solid #b1cff2;
    border-radius: 3px !important;
    color: $bluePrimary;
    background-color: $white;
    width: 100%;
    box-shadow: none;
    justify-content: center;
    overflow: hidden;
    cursor: default;
    position: relative;
    min-height: 32.8px;
    display: inline-flex;
    align-items: center;
    padding: 7px 10px;
    font-size: 14px;
    font-weight: 500;

    .skeleton {
      background-color: $greyBorderModal !important;
      height: 12px;
      width: 50%;
      border-radius: 100px;
    }

    .sb-icon {
      margin-right: 4px;
    }

    .copy-me-wrapper {
      position: absolute;
      opacity: 0;
      right: 5px;
      width: 30px;
      height: 20px;
      background: rgb(255,255,255);
      background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 43%, rgba(255,255,255,1) 100%);

      .copy-me {
        position: absolute;
        right: 0;
        cursor: pointer;
        margin: 4px 0 4px;
        display: block;
        width: 20px;
        height: 12px;
        background-image: url('~@/assets/img/SB-Icons/copy.svg');
        background-repeat: no-repeat;
        background-position: center;

        &:hover {
          background-image: url('~@/assets/img/SB-Icons/copy-hover.svg');
        }
      }
    }

    &:last-of-type {
      border-bottom-left-radius: 19px !important;
      border-bottom-right-radius: 19px !important;
    }

    &:hover .copy-me-wrapper {
      opacity: 1;
    }

    .waiting {
      color: #7C8B91;
    }
  }
}

#attachment-wrapper {
  ::v-deep .error {
    padding: 0 !important;
  }
}

::v-deep .editor-tag {
  padding: 0px 6px;
  border-radius: 9px;
  border: solid 1px $white;
  background-color: #4190ed;
  font-size: 12px;
  font-weight: 500;
  color: $white;
  white-space: nowrap;

  &.deleted {
    font-weight: 400 !important;
    color: $redPrimary !important;
    border: solid 1px $redPrimary !important;
  }
}
</style>

<style lang="scss">
  .button-popover {
    max-width: 450px;

    .popover-body {
      display: inline-flex;
      .blue {
        color: $bluePrimary !important;
        font-weight: 500;
      }
    }
  }
</style>
